import React, { FC } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { FaTwitter, FaYoutube } from 'react-icons/fa';
import { Link } from 'gatsby';

const Footer: FC = () => {
  return (
    <footer className="footer">
      <Container fluid className="text-muted">
        <Row>
          <Col md={4} className="text-center my-2">
            <div className="ms-2">
              &copy; {new Date().getFullYear()} <a href="https://promlabs.com/">PromLabs GmbH</a>
            </div>
          </Col>
          <Col md={4} className="text-center my-2">
            <a href="https://www.youtube.com/@PromLabs" className="me-4" target="_blank">
              <FaYoutube className="me-2" /> YouTube
            </a>
            <a href="https://twitter.com/promlabs" target="_blank">
              <FaTwitter className="me-2" /> Twitter
            </a>
          </Col>
          <Col md={4} className="text-center my-2">
            <Link className="ms-4 me-3" to="/about/">
              About
            </Link>
            <Link className="ms-4 me-3" to="/contact/">
              Contact
            </Link>
            <Link className="ms-4 me-3" to="/privacy/">
              Privacy
            </Link>
            <Link className="ms-4 me-3" to="/imprint/">
              Imprint
            </Link>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
